// route-animations.ts
import {animate, group, query, style, transition, trigger} from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  transition('* <=> *', [
    // Set fixed positioning for enter and leave elements
    query(':enter, :leave', [
      style({
        position: 'fixed',
        width: '100%'
      })
    ], {optional: true}),
    group([
      // Animate the entering component from right to left
      query(':enter', [
        style({transform: 'translateX(100%)'}),
        animate('0.5s ease-in-out', style({transform: 'translateX(0%)'}))
      ], {optional: true}),
      // Animate the leaving component from center to left
      query(':leave', [
        style({transform: 'translateX(0%)'}),
        animate('0.5s ease-in-out', style({transform: 'translateX(-100%)'}))
      ], {optional: true}),
    ])
  ])
]);
